import {
  Box,
  Divider,
  Flex,
  Group,
  Paper,
  ScrollArea,
  Space,
  Text,
  rem,
} from "@mantine/core";
import {
  IconBuilding,
  IconExclamationMark,
  IconMenu2,
} from "@tabler/icons-react";
import { PAGE_TABS_ACCESSORS } from "../../constants";

type YourPagesProps = {
  usePageTabs: () => {
    handlePageTabSelect: (tab: string) => void;
  };
  selectedPageTab: string;
};

export default function YourPages({
  usePageTabs,
  selectedPageTab,
}: YourPagesProps) {
  const { handlePageTabSelect } = usePageTabs();

  const tabs = [
    {
      label: PAGE_TABS_ACCESSORS.meter.label,
      icon: <IconMenu2 color="#6865fe" />,
      value: PAGE_TABS_ACCESSORS.meter.value,
    },
    {
      label: PAGE_TABS_ACCESSORS.billing.label,
      icon: <IconBuilding color="#13a0b6" />,
      value: PAGE_TABS_ACCESSORS.billing.value,
    },
    {
      label: PAGE_TABS_ACCESSORS.errorCodes.label,
      icon: <IconExclamationMark color="#ff5757" stroke={3} />,
      value: PAGE_TABS_ACCESSORS.errorCodes.value,
    },
  ];

  return (
    <>
      <Text c="#03045e" size="xl" fw={800}>
        Your Pages
      </Text>
      <Space h={"xs"} />
      <ScrollArea>
        <Group wrap="nowrap">
          {tabs?.map((tab, index) => (
            <Paper
              key={index}
              radius={"md"}
              h={rem(110)}
              w={rem(150)}
              onClick={() => {
                handlePageTabSelect(tab.value);
              }}
            >
              <Flex direction={"column"} h={"100%"}>
                <Box p={"md"}>
                  {tab.icon}
                  <Text c={"#03045e"} fw={800}>
                    {tab.label}
                  </Text>
                </Box>

                {tab.value === selectedPageTab ? (
                  <Box px={"xs"} mt={"auto"} mb={"sm"}>
                    <Divider
                      w={"100%"}
                      size="xl"
                      style={{
                        // visibility: activeTab ? "visible" : "hidden",
                        borderRadius: "4px",
                        borderColor: "#ff9fc2",
                      }}
                    />
                  </Box>
                ) : null}
              </Flex>
            </Paper>
          ))}
        </Group>
      </ScrollArea>
    </>
  );
}
